var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"icon-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('FontAwesomeIcon',{staticClass:"icon",attrs:{"icon":_vm.icon}}),(_vm.label)?_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }